export default function ServiceCard({ service }) {
  return (
    <div
      className="bg-white border-2 border-gray-200 rounded-xl p-6 md:p-8 transition-all duration-300 ease-in-out hover-elevate"
      data-testid={`card-service-${service.id}`}
    >
      <div className="flex flex-col items-center text-center">
        <i
          className={`${service.icon} text-4xl md:text-5xl text-[#FFA500] mb-4`}
          data-testid={`icon-service-${service.id}`}
        ></i>
        <h3 className="text-xl md:text-2xl font-heading font-semibold text-[#1F2937] mb-3">
          {service.title}
        </h3>
        <p className="text-base md:text-lg text-gray-600 leading-relaxed">
          {service.description}
        </p>
      </div>
    </div>
  );
}